import { useMemo } from 'react';

import { useDialogsList } from './useDialogsList';

export const useRequisiteSaveAs = (requisiteId?: string): string | null => {
  const dialogs = useDialogsList();

  return useMemo(() => {
    if (!requisiteId || !dialogs) {
      return null;
    }
    for (const dialog of dialogs) {
      const nodes = Array.isArray(dialog.nodes) ? dialog.nodes : [];
      for (const node of nodes) {
        const requisite = node.requisites?.find((item) => item.requisite_id === requisiteId);
        if (requisite) {
          return requisite.save_as;
        }
      }
    }
    return null;
  }, [dialogs, requisiteId]);
};
